export default __webpack_public_path__ + "static/media/qcmd.db6bd5e2.png";